import { InfoCard } from '@/components/cards/InfoCard';
import InfoCardSkeleton from '@/components/cards/InfoCardSkeleton';
import { formatAmount } from '@/lib/format';
import { useDynamicLocale } from '@/hoslog-intl';
import { StoreInformation, UserFriendIcon } from '@/icons';
import { MoneyBillIcon } from '@/icons/money-bill-icon';
import { WalletIcon } from '@/icons/wallet-icon';
import { ReferralAnalytics } from '@/services/dashboard/referralReports/referralReports.types';

interface ReferralOverviewCardsProps {
  overview?: ReferralAnalytics;
  isLoading?: boolean;
}

export const ReferralOverviewCards = ({ overview, isLoading = false }: ReferralOverviewCardsProps) => {
  const { t } = useDynamicLocale();
  if (isLoading) return <InfoCardSkeleton count={4} />;

  const cards = [
    {
      title: t('dashboard.referralReports.cards.todaysReferrers'),
      info: (overview?.todaysReferrersCount ?? 0).toLocaleString(),
      helperText: '枠',
      icon: WalletIcon,
      titleWrap: 'always' as const,
    },
    {
      title: t('dashboard.referralReports.cards.monthlyReferral'),
      info: (overview?.monthlyReferralCount ?? 0).toLocaleString(),
      helperText: '枠',
      icon: MoneyBillIcon,
      titleWrap: 'always' as const,
    },
    {
      title: t('dashboard.referralReports.cards.totalReferral'),
      info: (overview?.totalReferralCount ?? 0).toLocaleString(),
      helperText: '枠',
      icon: StoreInformation,
      action: { label: '詳細', link: '' },
      titleWrap: 'always' as const,
    },
    {
      title: t('dashboard.referralReports.cards.totalPointIssued'),
      info: formatAmount(overview?.totalPointIssuedCount ?? 0, ''),
      helperText: '円',
      icon: UserFriendIcon,
      action: { label: '詳細', link: '' },
      titleWrap: 'always' as const,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map(({ title, titleWrap, info, helperText, icon, action }) => (
        <InfoCard
          key={title}
          title={title}
          titleWrap={titleWrap}
          info={info}
          helperText={helperText}
          icon={icon}
          action={action}
          className="min-h-[100px]"
        />
      ))}
    </div>
  );
};
